import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

import { GuildUsersDashboard } from '../../../features/guild-users'
import { USERS_COMBOS_IDS } from '../../../pages/guild-users/constants'
import { useCombos } from '../../../features/combos'

export const GuildUsersPage = ({ classes = {} }) => {
  useCombos(USERS_COMBOS_IDS)

  return (
    <Routes>
      <Route exact path="" element={<GuildUsersDashboard />} />
      <Route path="*" element={<Navigate to="" replace />} />
    </Routes>
  )
}
